"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, LoaderCircle } from "lucide-react";
import { useRef } from "react";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import { canAnimatePointer, loadGsap } from "@/lib/gsap";
import { cn } from "@/lib/utils";
type ProposalActionButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  submit?: boolean;
  text: string;
};
export function ProposalActionButton(t0) {
  const $ = _c(15);
  const {
    disabled: t1,
    loading: t2,
    onClick,
    submit: t3,
    text
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const submit = t3 === undefined ? false : t3;
  const buttonRef = useRef(null);
  const iconRef = useRef(null);
  let t4;
  if ($[0] !== disabled) {
    t4 = async () => {
      if (!canAnimatePointer()) {
        return;
      }
      const button = buttonRef.current;
      const icon = iconRef.current;
      if (!button || disabled) {
        return;
      }
      const gsap = await loadGsap();
      gsap.killTweensOf(button);
      if (icon) {
        gsap.killTweensOf(icon);
      }
      gsap.to(button, {
        duration: 0.14,
        ease: "power2.out",
        overwrite: "auto",
        scale: 1.01,
        y: 0
      });
      if (icon) {
        gsap.to(icon, {
          duration: 0.18,
          ease: "power2.out",
          overwrite: "auto",
          x: 4
        });
      }
    };
    $[0] = disabled;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handlePointerEnter = t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = async () => {
      if (!canAnimatePointer()) {
        return;
      }
      const button_0 = buttonRef.current;
      const icon_0 = iconRef.current;
      if (!button_0) {
        return;
      }
      const gsap_0 = await loadGsap();
      gsap_0.killTweensOf(button_0);
      if (icon_0) {
        gsap_0.killTweensOf(icon_0);
      }
      gsap_0.to(button_0, {
        duration: 0.16,
        ease: "power2.out",
        overwrite: "auto",
        scale: 1,
        y: 0
      });
      if (icon_0) {
        gsap_0.to(icon_0, {
          duration: 0.16,
          ease: "power2.out",
          overwrite: "auto",
          x: 0
        });
      }
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const handlePointerLeave = t5;
  const t6 = disabled && "cursor-not-allowed bg-[#555555] text-[#b6b6b6]";
  let t7;
  if ($[3] !== t6) {
    t7 = cn("group h-12.25 rounded-xl border border-transparent enabled:hover:border-primary-300 bg-primary-300 px-6 text-[18px] font-medium transition-[background-color,color,box-shadow] duration-150 ease-out enabled:hover:shadow-[0_18px_35px_rgba(255,92,0,0.2)]", t6);
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = submit ? "submit" : "button";
  let t9;
  if ($[5] !== loading || $[6] !== text) {
    t9 = <span className="pointer-events-none flex items-center gap-2">{loading ? <><LoaderCircle className="size-4 animate-spin" /><span>Enviando</span></> : <><span>{text}</span><span ref={iconRef}><ArrowRight className="size-4" /></span></>}</span>;
    $[5] = loading;
    $[6] = text;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== disabled || $[9] !== handlePointerEnter || $[10] !== onClick || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t10 = <ButtonRadialFill ref={buttonRef} className={t7} disabled={disabled} onClick={onClick} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave} type={t8}>{t9}</ButtonRadialFill>;
    $[8] = disabled;
    $[9] = handlePointerEnter;
    $[10] = onClick;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}